/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_RetryInputs */

const he_error_retry = /** @type {(inputs: Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נסה שוב`)
};

const en_error_retry = /** @type {(inputs: Error_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Again`)
};

/**
* | output |
* | --- |
* | "Try Again" |
*
* @param {Error_RetryInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const error_retry = /** @type {((inputs?: Error_RetryInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_RetryInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_error_retry(inputs)
	return en_error_retry(inputs)
});